import { Box, Typography } from "@mui/material";
import HintTooltip from "../../../common-components/HintTooltip";
import { countryOptions } from "../../../utility/constants";
import { landingColors } from "../landingColors";

const LiveCountriesHint = () => (
  <HintTooltip
    marker="*"
    ariaLabel="Nigerian. See all countries we're live in"
    content={
      <>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 14,
            color: landingColors.textPrimary,
            mb: 1.25,
          }}
        >
          Live in {countryOptions.length} countries
        </Typography>
        <Box
          component="ul"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0.75,
            m: 0,
            p: 0,
            listStyle: "none",
          }}
        >
          {countryOptions.map(({ label, value }) => (
            <Typography
              component="li"
              key={value}
              sx={{
                border: `1px solid ${landingColors.border}`,
                borderRadius: 6,
                px: 1.25,
                py: 0.25,
                fontSize: 13,
                color: landingColors.textSecondary,
              }}
            >
              {label}
            </Typography>
          ))}
        </Box>
      </>
    }
  >
    Nigerian
  </HintTooltip>
);

export default LiveCountriesHint;
